module.exports = __webpack_public_path__ + "img/yun1.5d8ea272.png";